import axios from 'axios'
import { toSnakeCase, toCamelCase } from './data-format'
import { getToken, setToken, removeAll, removeToken } from '@/utils/auth'
import { Message } from 'element-ui';
import store from '@/store'
import { refreshAccessToken } from '@/api/security'

const http = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 30000
})

// 401刷新锁、等待队列
let isRefreshing = false
let waitQueue = []
// 定时刷新定时器标识
let refreshTimer = null
// accessToken有效期，假设后端30分钟，提前5分钟刷新
const ACCESS_EXPIRE_MS = 25 * 60 * 1000

// 启动定时静默刷新
function startTokenTimer() {
    stopTokenTimer()
    refreshTimer = setInterval(async () => {
        const userInfo = store.getters.adminUserInfo || {}
        const rt = userInfo.refreshToken
        if (!rt || !getToken()) {
            stopTokenTimer()
            return
        }
        try {
            // 静默刷新，不弹窗
            const res = await refreshAccessToken({ refreshToken: rt }, { unformat: true })
            setToken(res.data.accessToken)
            console.log('token定时自动刷新成功')
        } catch (err) {
            // refreshToken过期，停止定时并退出登录
            stopTokenTimer()
            logoutClear()
        }
    }, ACCESS_EXPIRE_MS)
}

// 清除定时器
function stopTokenTimer() {
    if (refreshTimer) {
        clearInterval(refreshTimer)
        refreshTimer = null
    }
}

// 登出统一清理
function logoutClear() {
    stopTokenTimer()
    removeToken()
    removeAll()
    store.dispatch("setAdminUserInfo", null)
    waitQueue = []
    location.reload()
}

http.interceptors.request.use(
    config => {
        const token = getToken()
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        config.headers['accept-language'] = 'zh_tc'
        if (!config.unformat) {
            config.params = toSnakeCase(config.params)
            config.data = toSnakeCase(config.data)
        }
        return config
    },
    error => Promise.reject(error)
)

http.interceptors.response.use(
    response => {
        // 登录成功后开启定时刷新
        if (response.config.url.includes('login')) {
            startTokenTimer()
        }
        if (response.headers['content-type'] === 'application/json') {
            response.data = toCamelCase(response.data)
        }
        return response
    },
    async error => {
        if (!error.response) {
            Message.error('网络异常，请检查网络连接')
            return Promise.reject(error)
        }
        const { status } = error.response
        const originConfig = error.config

        // accessToken过期401被动刷新兜底
        if (status === 401 && !originConfig._retry) {
            const userInfo = store.getters.adminUserInfo || {}
            const rt = userInfo.refreshToken
            if (!rt) {
                logoutClear()
                return Promise.reject(error)
            }
            if (isRefreshing) {
                return new Promise(resolve => {
                    waitQueue.push(newToken => {
                        originConfig.headers.Authorization = `Bearer ${newToken}`
                        resolve(http(originConfig))
                    })
                })
            }
            isRefreshing = true
            originConfig._retry = true
            try {
                const res = await refreshAccessToken({ refreshToken: rt }, { unformat: true })
                const newAccess = res.data.accessToken
                setToken(newAccess)
                waitQueue.forEach(cb => cb(newAccess))
                waitQueue = []
                originConfig.headers.Authorization = `Bearer ${newAccess}`
                return http(originConfig)
            } catch (refreshErr) {
                logoutClear()
                return Promise.reject(refreshErr)
            } finally {
                isRefreshing = false
            }
        }

        if (status === 500) {
            Message.error(error.response.data?.message || '服务器错误')
        } else {
            Message.error(error.response.data?.error_message || '请求失败')
        }
        return Promise.reject(error)
    }
)

export default http